import React from "react"
import PropTypes from "prop-types"

import Icon from "app/static/frontend/components/Icon"
import Tooltip from "app/static/frontend/components/Tooltip"

// Define styles
const divContainerstyles = {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: "15px",
}

const iconStyles = {
    marginRight: "-5px",
}

// Render an Error indicator in a cell
export const ErrorCell = ({ tooltipLabel, iconName, iconClassName }) => (
    <div style={divContainerstyles}>
        <Tooltip label={tooltipLabel}>
            <div>
                <Icon name={iconName} className={iconClassName} style={iconStyles} />
            </div>
        </Tooltip>
    </div>
)

ErrorCell.propTypes = {
    tooltipLabel: PropTypes.string,
    iconName: PropTypes.string,
    iconClassName: PropTypes.string,
}

ErrorCell.defaultProps = {
    tooltipLabel: "Something went wrong with saving this cell value",
    iconName: "exclamation-circle",
    iconClassName: "cell-error",
}
